<template>
  <b-form @submit.prevent="submitForm">

     <b-form-group label-for="input-code">
      <template v-slot:label>{{ $t("featureCode") }} <span class="text-danger">(*)</span></template>
      <!-- không được phép đổi mã code -->
      <b-form-input id="input-code" v-model = "code" minlength="2" maxlength="100" readonly/>
    </b-form-group>

    <b-form-group label-for="input-config">
      <template v-slot:label>{{ $t("featureName") }} <span class="text-danger">(*)</span></template>
      <b-form-input id="input-config" v-model="localName" minlength="2" maxlength="200" required/>
    </b-form-group>
    <b-form-group>
          <template v-slot:label>{{ $t("description") }} <span class="text-danger">(*)</span></template>
          <b-form-textarea v-model="localDescribe" id="input-describe" minlength="2" rows="3" maxlength="500" required/>
    </b-form-group>

    <div v-if="formErrorMsg" class="text-danger my-2">{{ formErrorMsg }}</div>

    <b-form-checkbox v-model="localIsDefault">
      {{ $t("defaultTurnOn") }}
    </b-form-checkbox>

    <div class="text-right pt-3">
      <b-button type="button" variant="secondary" class="mr-3" @click="onClickCancel" :disabled="isSubmitting">{{ $t("cancel") }}</b-button>
      <b-button type="submit" variant="primary" :disabled="isSubmitting">{{ $t("update") }}</b-button>
    </div>
  </b-form>
</template>

<style lang="scss" scoped>

</style>

<script lang="ts">
  import {Component, Prop} from 'vue-property-decorator';
  import _ from "lodash";
  import BaseComponent from "@/components/BaseComponent";
  import * as featureConfigService from "@/service/featureConfigService";
import { Status } from '../enums/EnableStatus';
  @Component
  export default class EditConfigModal extends BaseComponent {
    @Prop({ required: true }) code!: string;
    @Prop({ required: true }) name!: string;    
    @Prop({ required: true }) description: string;
    @Prop({ required: true }) isDefault: number;
    formErrorMsg = "";
    isSubmitting = false;
    localName = "";
    localDescribe = "";
    localIsDefault = false;

    created() {
      this.localName = this.name;
      this.localDescribe = this.description?? "";
      this.localIsDefault = this.isDefault === Status.ENABLE;
    }

    onClickCancel() {
        this.$bvModal.hide('edit-feature-modal');
    }

    async submitForm() {
      this.formErrorMsg = "";
      this.isSubmitting = true;

       ///trim inputs
      const trimmedName = this.localName.trim();
      const trimeddescription = this.localDescribe.trim();
      
      //check required fields name
      if (!trimmedName) {
        this.formErrorMsg = this.$t("nameFeatureRequired").toString();
        this.isSubmitting = false;
        return;
      }

      //check required fields description
      if (!trimeddescription) {
        this.formErrorMsg = this.$t("descriptionFeatureRequire").toString();
        this.isSubmitting = false;
        return;
      }
      try {
        const data = {
          code: this.code.trim(),
          name: trimmedName,
          description: trimeddescription,
          isDefault: this.localIsDefault ? Status.ENABLE : Status.DISABLE
        };
        const res = await featureConfigService.updateByCode(data);
        this.toastSuccessDelay(this.$t("updateSuccessful").toString());
        this.$emit("editFeature"); //load lại fetchMeeting
        this.$bvModal.hide('edit-feature-modal');
      } 
      catch (e) {
        this.toastErrorOldType(e);  
      } finally {
        this.isSubmitting = false;
      }
    }
  }
</script>
